import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=f6aef06a"
import script from "./ProfileInfo.vue?vue&type=script&lang=ts"
export * from "./ProfileInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6aef06a')) {
      api.createRecord('f6aef06a', component.options)
    } else {
      api.reload('f6aef06a', component.options)
    }
    module.hot.accept("./ProfileInfo.vue?vue&type=template&id=f6aef06a", function () {
      api.rerender('f6aef06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/ProfileInfo.vue"
export default component.exports